module.exports = __webpack_public_path__ + "static/media/Dashboard_10-GraphicStories.a7b0a055.jpg";